// @ts-check
import SpinnerButton from "ReactComponents/Shared/FormInputs/spinner-button";
import TrialLicenseMediaTypeRadioItem from "./trial-license-media-type-radio-item";
// import { trialLicenseMediaTypeListComposer } from "ReactReducers/TrialLicense/TrialLicenseMediaTypeList/trial-license-media-type-list-composer";
import React from "react";

class TrialLicenseMediaTypeList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: 0
        };
    }

    render() {
        if (!this.props.trialLicenseProducts) return null;

        return (
            <div className="trial-license-media-type-list">
                <h1
                    dangerouslySetInnerHTML={{
                        __html: this.props.trialLicenseProducts[this.state.selectedIndex]
                            .TrialLicenseStatusTitle
                    }}
                />

                <div>
                    {this.props.trialLicenseProducts.map((trialLicenseProduct, index) => {
                        return (
                            <TrialLicenseMediaTypeRadioItem
                                onClick={() => {
                                    this.setState({ selectedIndex: index });
                                }}
                                key={index}
                                selected={index == this.state.selectedIndex}
                                label={trialLicenseProduct.MediaType}
                            />
                        );
                    })}
                </div>

                <div
                    className="content-rich-text"
                    dangerouslySetInnerHTML={{
                        __html: this.props.trialLicenseProducts[this.state.selectedIndex]
                            .TrialLicenseStatusText
                    }}
                ></div>

                {!this.props.trialLicenseOrdered &&
                    this.props.trialLicenseOrdered !== undefined &&
                    this.props.trialLicenseProducts[this.state.selectedIndex].OrderAccessButtonText &&
                    this.props.trialLicenseProducts[this.state.selectedIndex].OrderAccessButtonText.length >
                        0 && (
                        <SpinnerButton
                            isLoading={this.props.isLoading}
                            onClick={() => {
                                this.props.onClick(this.props.trialLicenseProducts[this.state.selectedIndex]);
                            }}
                            className="trial-license-media-type-list__button button button--slim"
                            context="Lægger i kurv..."
                            label={
                                this.props.trialLicenseProducts[this.state.selectedIndex]
                                    .OrderAccessButtonText
                            }
                        />
                    )}
            </div>
        );
    }
}

export default TrialLicenseMediaTypeList;
